module.exports = __webpack_public_path__ + "static/CareLabel-v5-no-border-30579ae050cfe3ba7064d7f01541476d.svg";